import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { NgbModalModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { DecisionRecord } from '../../models/decision.model';
import { AuthService } from '../../services/auth.service';
import { PlayerApiService } from '../../services/player-api.service';
import { PlayerDataService } from '../../services/player-data.service';

@Component({
  selector: 'faculty-landing-screen',
  standalone: true,
  imports: [ CommonModule,   
      FormsModule,
      RouterModule,
      NgbModalModule],
  templateUrl: './faculty-landing-screen.component.html',
  styleUrl: './faculty-landing-screen.component.css'
})
export class FacultyLandingScreenComponent implements OnInit {
   /** Sidebar open/close status for mobile/tablet */
  isSidebarOpen: boolean = false;

  tabs: any[] = [
    { label: 'Faculty Dashboard', path: 'facultyDashboard', enabled: true },
    { label: 'Generate Report', path: 'generateReport', enabled: true },
   
  ]
  currentRound: number = 0;
  compdtl: any;
  roundData: any;
  visited = new Set<string>();
  currentStatus: string = "";
  username: string = '';

  constructor(private playerData: PlayerDataService, private api: PlayerApiService, private authService: AuthService, private router: Router, private route: ActivatedRoute, private toaster: ToastrService, private modalService: NgbModal) {
     // Auto-close sidebar when any route is navigated
    this.router.events.subscribe(() => {
      this.isSidebarOpen = false;
    });
   }

    // OPTIONAL methods if you want explicit functions
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  async ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const playerId = user.userId;
    this.username = user.username;
    try {
    } catch (err) {
      console.error('Error loading player data', err);
    }

  }


  navigateTo(tab: any) {
    if (!tab.enabled) return;
    // relative navigation makes it go to /player-dashboard/<tab.path>
    this.router.navigate([tab.path], { relativeTo: this.route });
  }

  markVisited(path: string) {
    this.visited.add(path);
  }

  
  onLogout() {
    this.authService.logout();
  }


}
